/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiTransactionSummaryByCountry
 */
export interface ApiTransactionSummaryByCountry {
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionSummaryByCountry
     */
    countryCode: string;
    /**
     * 
     * @type {number}
     * @memberof ApiTransactionSummaryByCountry
     */
    totalAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof ApiTransactionSummaryByCountry
     */
    time: Date;
}

/**
 * Check if a given object implements the ApiTransactionSummaryByCountry interface.
 */
export function instanceOfApiTransactionSummaryByCountry(value: object): value is ApiTransactionSummaryByCountry {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    return true;
}

export function ApiTransactionSummaryByCountryFromJSON(json: any): ApiTransactionSummaryByCountry {
    return ApiTransactionSummaryByCountryFromJSONTyped(json, false);
}

export function ApiTransactionSummaryByCountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiTransactionSummaryByCountry {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'totalAmount': json['totalAmount'],
        'time': (new Date(json['time'])),
    };
}

export function ApiTransactionSummaryByCountryToJSON(json: any): ApiTransactionSummaryByCountry {
    return ApiTransactionSummaryByCountryToJSONTyped(json, false);
}

export function ApiTransactionSummaryByCountryToJSONTyped(value?: ApiTransactionSummaryByCountry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countryCode': value['countryCode'],
        'totalAmount': value['totalAmount'],
        'time': value['time'].toISOString(),
    };
}

